module.exports = __webpack_public_path__ + "pc/img/wenjian.a688bf9d.png";